import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { createThunkErrorHandler } from '../../utils/handleThunkError.js';
import { handlePending } from '../../utils/handlePending.js';
import { getAll } from '../../http/balanceAPI.js';

export const getOrdersBalance = createAsyncThunk(
    'balance/getOrdersBalance',
    async function (params = {}, { rejectWithValue, dispatch, getState }) {

        dispatch(clearErrors())
        const state = getState().balance;
        const page = params.page ?? state.page;
        const limit = params.limit ?? state.limit;

        try {
            const data = await getAll(page, limit)
            return data
        } catch (e) {
            return rejectWithValue(e?.code || 'Failed')
        }

    }
)


const balanceSlice = createSlice({
    name: 'balance',
    initialState: {
        errors: {},
        globalError: null,
        isLoading: false,
        isDataLoading: false,
        count: 0,
        limit: 30,
        page: 1,
        data: [],

    },
    reducers: {
        clearErrors: (state) => {
            state.errors = {}
            state.globalError = null
        },

        clearGlobalError: (state) => {
            state.globalError = null
        },

        setPageBalance(state, action) {
            const { page } = action.payload;
            state.page = page;
        },
    },

    extraReducers: builder => {
        builder

            .addCase(getOrdersBalance.rejected, createThunkErrorHandler("BALANCE"))
            .addCase(getOrdersBalance.pending, handlePending)
            .addCase(getOrdersBalance.fulfilled, (state, action) => {
                state.isLoading = false
                state.data = action.payload.data
                state.count = action.payload.count
                state.errors = {}
            })

    }
});

export const {
    clearErrors,
    clearGlobalError,
    setPageBalance
} = balanceSlice.actions;

export default balanceSlice.reducer;